var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVStyle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 704 320"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  fillRule: "evenodd",
  d: "M1173.45 1961.51h-2311.07L19.177-132z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  fillRule: "evenodd",
  d: "M1153.04 1961.51h-2311.07L-1.229-132z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1132.63 1961.51h-2311.06L-21.635-132z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  fillRule: "evenodd",
  d: "M2006 1961.51H-305.067L851.734-132z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  fillRule: "evenodd",
  d: "M1985.6 1961.51H-325.472L831.328-132z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M2026.41 1961.51H-284.661L872.139-132z",
  clipRule: "evenodd"
})));
export default SvgVStyle;